export default __webpack_public_path__ + "static/media/news_background.8b6809a0.png";